import React from 'react';
import PropTypes from 'prop-types';
import Translate from './Translate';
import PriceFormatter from './formatterComponents/PriceFormatter';
import BookingOverviewConfirm from './bookingOverview/BookingOverviewConfirm';
import BookingOverviewLineItems from './bookingOverview/BookingOverviewLineItems';
import BookingOverviewMetadata from './bookingOverview/BookingOverviewMetadata';
import { OPTION } from '../constants/TravelAgencyTypes';
import BookingOverviewHOC from '../hoc/BookingOverviewHOC';

// eslint-disable-next-line arrow-parens
const BookingOverview = props => {
  const checkboxProps = {};
  const { payment } = props.order;
  let calculatedFee;
  let rootClassName = 'booking-overview-container booking-step';

  if (props.main) {
    rootClassName += ' booking-overview-container--main';
  }

  // @todo create reducer function to retrieve selected option.
  if (payment) {
    const selected = payment.paymentOptions.filter(
      option =>
        payment.paymentOptionSelected === option.creditCardExternalId &&
        (option.calculatedFee && parseFloat(option.calculatedFee.amount) > 0)
    );
    const { length, 0: first } = selected;

    if (Array.isArray(selected) && length === 1) {
      ({ calculatedFee } = first);
    }
  }

  checkboxProps.checked = props.appearance.bookingOverviewExpanded;

  const totalPriceWithCardFee = { ...props.order.bookingPrice.totalPrice };
  if (calculatedFee) {
    totalPriceWithCardFee.amount += parseFloat(calculatedFee.amount);
  }

  const selectedPayment = props.order.payment && props.order.payment.paymentOptionSelected
    ? props.order.payment.paymentOptionSelected
    : '';

  const bookingConfirmation = (
    <BookingOverviewConfirm
      acceptedTermsAndConditions={
        props.appearance.acceptedTermsAndConditions
      }
      acceptTerms={props.actions.acceptTerms}
      agencyOptionBooking={
        props.order.agency && props.order.type === OPTION
      }
      disabled={props.order.adults <= 0}
      errors={props.errors}
      hasLongText={
        props.order.salesMarket === '280' || // Germany
        props.order.salesMarket === '040' // Austria
      }
      isCreditAgency={props.order.agency.creditAgency}
      isSubmitLoading={props.appearance.submitLoading}
      paymentOptionSelected={selectedPayment}
      paymentValidate={props.paymentValidate}
      request={props.order.request}
      salesChannel={props.order.salesChannel}
      startSubmitLoading={props.actions.startSubmitLoading}
      termsAndConditionsLink={
        props.appearance.termsAndConditionsLink
      }
      productCode={
        props.rental.information.productCode
      }
    />
  );

  return (
    <aside className={rootClassName}>
      <div className="booking-overview-container-inner">
        <div className="booking-overview-wrap" id="booking-overview-wrap">
          <div className="booking-overview card basket-bar">
            <input
              className="booking-overview-card-trigger"
              id="booking-overview-card-trigger"
              name="booking-overview-card-trigger"
              type="checkbox"
              {...checkboxProps}
              readOnly
            />
            <label
              className="card__header booking-overview__header"
              htmlFor="booking-overview-card-trigger"
              onClick={props.onToggle}
            >
              <div className="house-header">
                <i aria-hidden="true" className="fa fa-angle-down" />
                <Translate
                  className="booking-overview__header-title"
                  content="My booking"
                />
              </div>
              <div>
                {props.main &&
                  (props.appearance.bookingOverviewExpanded ? (
                    <span className="booking-overview__header-button">
                      <Translate content="Hide" />
                    </span>
                  ) : (
                    <span className="booking-overview__header-price">
                      <span className="booking-overview__header-price-label">
                        <Translate content="Total" />
                        {' '}
                      </span>
                      <PriceFormatter price={totalPriceWithCardFee} />
                    </span>
                  ))}
                </div>
            </label>

            <div className="card__body booking-overview__body">
              <BookingOverviewMetadata
                actions={props.actions}
                appearance={props.appearance}
                errors={props.errors}
                order={props.order}
                rental={props.rental}
              />

              <BookingOverviewLineItems
                calculatedFee={calculatedFee}
                order={props.order}
                rental={props.rental}
                totalPriceWithCardFee={totalPriceWithCardFee}
              />

              {(props.main && !props.appearance.isNarrow) && (
                bookingConfirmation
              )}
            </div>
            {(!props.main && props.appearance.isNarrow) && (
              bookingConfirmation
            )}
          </div>
        </div>
      </div>
    </aside>
  );
};

BookingOverview.PropTypes = {
  main:PropTypes.bool,
  appearance:PropTypes.object.isRequired,
  className:PropTypes.string,
  order:PropTypes.object.isRequired,
  rental:PropTypes.object.isRequired,
  onToggle:PropTypes.func.isRequired,
  errors:PropTypes.object.isRequired,
  paymentValidate:PropTypes.func.isRequired,
  actions:PropTypes.object.isRequired,
};

export default BookingOverviewHOC(BookingOverview);
